export default __webpack_public_path__ + "static/media/home-bg-flip.fd2d48fb.png";